export default {
    alerts: {
        sendInformationSuccess: {
            id: 'information.alerts.sendInformationSuccess'
        }
    }
};
